import InvestStatementPageNew from './InvestStatementPageNew';

export default InvestStatementPageNew;
